import React, { useState } from "react";
import { Button } from "@mui/material";
import { MdAdd } from "react-icons/md";
import AddGiftModal from "../modal/AddGiftModal";

type Props = {
    onGiftAdded?: () => void;
    variant?: "contained" | "outlined" | "text";
    size?: "small" | "medium" | "large";
    color?: "primary" | "secondary" | "success" | "error" | "info" | "warning";
    startIcon?: React.ReactNode;
    sx?: any;
};

const AddGiftButton = ({
    onGiftAdded,
    variant = "contained",
    size = "medium",
    color = "primary",
    startIcon = <MdAdd />,
    sx,
}: Props) => {
    const [open, setOpen] = useState(false);

    const handleGiftAdded = () => {
        onGiftAdded?.();
        setOpen(false);
    };

    return (
        <>
            <Button
                variant={variant}
                size={size}
                color={color}
                startIcon={startIcon}
                onClick={() => setOpen(true)}
                sx={{ width: "fit-content", ...sx }}
            >
                إضافة جديد
            </Button>
            <AddGiftModal
                open={open}
                setOpen={setOpen}
                onGiftAdded={handleGiftAdded}
            />
        </>
    );
};

export default AddGiftButton;
